import { render, staticRenderFns } from "./Verzehrart.vue?vue&type=template&id=4d5b251e"
import script from "./Verzehrart.vue?vue&type=script&lang=ts"
export * from "./Verzehrart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports